import { render, staticRenderFns } from "./DialogPseudo.vue?vue&type=template&id=97979586&scoped=true&"
var script = {}
import style0 from "./DialogPseudo.vue?vue&type=style&index=0&id=97979586&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97979586",
  null
  
)

export default component.exports